// extracted by mini-css-extract-plugin
export default {"layout":"UserProfile_layout__1hSoD","column":"UserProfile_column__4uvzF","userImage":"UserProfile_userImage__DEbct","sm":"UserProfile_sm__ZZ0Xt","lg":"UserProfile_lg__ndk7T"};